import ReportHeader from './ReportHeader';
export default ReportHeader;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/index.js